const config = {
  HOMEPAGE: "http://dagajoga.pl/",
};


export default config;
